import React from 'react';
export function Testimonials() {
  return <section id="testimonials" className="py-16 bg-gray-50" data-id="element-537" data-mp="2jykxcz42m9l8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-538" data-mp="3kq47z7nkr0os">
        <div className="text-center mb-16" data-id="element-539" data-mp="3fznvbprkvj3h">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3A4A46] mb-4" data-id="element-540" data-mp="3fym9cq90xc6z">
            What Business Owners Are Saying
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-541" data-mp="3ayhzhj2mffpq">
            Don't just take our word for it — hear from the small businesses
            we've helped
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-542" data-mp="321z8icdya1vs">
          {/* Testimonial 1 - Brittany */}
          <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-543" data-mp="2s1qbwxg1qefv">
            <div className="flex items-center mb-4" data-id="element-544" data-mp="2s3jhe9exasma">
              <div className="text-[#8A9A5B]" data-id="element-545" data-mp="v9ydr4zhpj73">
                {[...Array(5)].map((_, i) => <span key={i} className="text-2xl" data-id="element-546" data-mp="q9u0roxsj6lm" data-mpi={i}>
                    ★
                  </span>)}
              </div>
            </div>
            <blockquote className="text-gray-700 mb-6 italic" data-id="element-547" data-mp="h816hkw3kaiw">
              "I'd been running everything in spreadsheets and was nervous about
              moving to QuickBooks. Jaime made the switch easy, helped set it
              up, explained everything, and showed me how to use it. Now I feel
              confident keeping up with my books."
            </blockquote>
            <div className="flex items-center" data-id="element-548" data-mp="zwy2pub21d3r">
              <div className="h-12 w-12 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-bold text-xl" data-id="element-549" data-mp="14v9ck51cnnlz">
                B
              </div>
              <div className="ml-4" data-id="element-550" data-mp="q4jz0w0f1wey">
                <p className="font-medium text-[#3A4A46]" data-id="element-551" data-mp="v57mx8tclx4y">Brittany</p>
              </div>
            </div>
          </div>
          {/* Testimonial 2 - Scott */}
          <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-552" data-mp="1it7c44b0hfhf">
            <div className="flex items-center mb-4" data-id="element-553" data-mp="1nn22trp1auq0">
              <div className="text-[#8A9A5B]" data-id="element-554" data-mp="1xi0nba9elvyn">
                {[...Array(5)].map((_, i) => <span key={i} className="text-2xl" data-id="element-555" data-mp="1siwg2p61i8ay" data-mpi={i}>
                    ★
                  </span>)}
              </div>
            </div>
            <blockquote className="text-gray-700 mb-6 italic" data-id="element-556" data-mp="1ofzpoca9d7wg">
              "I used to stress over bookkeeping and the little details. Now I
              can just focus on running my business and doing what I love.
              Knowing the financial side is in good hands gives me peace of
              mind."
            </blockquote>
            <div className="flex items-center" data-id="element-557" data-mp="19qlgp5algshl">
              <div className="h-12 w-12 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-bold text-xl" data-id="element-558" data-mp="14ud707f61rht">
                S
              </div>
              <div className="ml-4" data-id="element-559" data-mp="vsdp7cwbujdt">
                <p className="font-medium text-[#3A4A46]" data-id="element-560" data-mp="vrc3mehoqehu">Scott</p>
              </div>
            </div>
          </div>
          {/* Testimonial 3 - Taylor */}
          <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-561" data-mp="32h5w28exotkr">
            <div className="flex items-center mb-4" data-id="element-562" data-mp="32j08eyc53dd8">
              <div className="text-[#8A9A5B]" data-id="element-563" data-mp="37f7fiug9uuwr">
                {[...Array(5)].map((_, i) => <span key={i} className="text-2xl" data-id="element-564" data-mp="3cetsr3w3ob5k" data-mpi={i}>
                    ★
                  </span>)}
              </div>
            </div>
            <blockquote className="text-gray-700 mb-6 italic" data-id="element-565" data-mp="3gekolm0hhhgy">
              "I messed up my QuickBooks® and didn't know where to start. She
              cleaned everything up quickly, explained what was wrong, and
              showed me how to handle things correctly going forward. I
              completely trust her and wouldn't hesitate to recommend her
              services to any small business owner."
            </blockquote>
            <div className="flex items-center" data-id="element-566" data-mp="210q1i5gwd147">
              <div className="h-12 w-12 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-bold text-xl" data-id="element-567" data-mp="20xu36g150af8">
                T
              </div>
              <div className="ml-4" data-id="element-568" data-mp="1lxoltds2v2ch">
                <p className="font-medium text-[#3A4A46]" data-id="element-569" data-mp="1luk9ft4gl0aq">Taylor</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}